<mat-select
  [compareWith]="compareWith"
  [formControl]="innerControl"
  [placeholder]="placeholder"
  (keydown)="onKeydown($event)"
  (selectionChange)="onSelectionChange($event)"
  (openedChange)="onOpenedChange($event)">
  @if (options.length > 10) {
    <mat-option (click)="$event.stopPropagation()" class="option__filter">
      <mat-form-field appearance="fill" class="option__filter-field">
        <input
          matInput
          #filterInput
          [formControl]="filterControl"
          (keydown)="onKeydown($event)"
          (click)="$event.stopPropagation()"
          placeholder="Filter..."
          autocomplete="off" />
      </mat-form-field>
    </mat-option>
  }
  @if (allowNullify) {
    <mat-option>– {{ 'ALL' | translate }} –</mat-option>
  }
  @for (option of filteredOptions; track option) {
    <mat-option [value]="option[valueField]">
      <ng-container
        [ngTemplateOutlet]="optionTemplate || defaultTemplate"
        [ngTemplateOutletContext]="{ $implicit: option }"></ng-container>
    </mat-option>
  }
</mat-select>

<ng-template #defaultTemplate let-option>
  {{ displayFn(option) }}
</ng-template>
